<template>
    <div>
      <v-card-title>
        {{ set_post.title }}
      </v-card-title>
      <v-divider class="mx-2" />
      <v-card-text class="text-center">
	<v-row>
		<v-col>
			<div class="aspect-ratio-16x9">
				        <iframe
            					width="600"
            					height="340"
            					:src="'https://www.youtube.com/embed/'+set_post.youtube_code"
            					frameborder="0"
            					allowfullscreen
          				></iframe>
			</div>
		</v-col>
	</v-row>
      </v-card-text>
      <v-divider class="mx-2" />
      <v-card-text v-html="contentQuill"></v-card-text>
    </div>
</template>
<script>
  export default {
    data: () => ({
      formData: {
        title: '',
        content_with_images: '',
        // 다른 필드들에 대한 초기값도 추가할 수 있습니다.
      },
    }),
    props:['set_post'],
    methods:{
     
    },
    computed:{
    	contentQuill() {
        	var html_content = this.set_post.content.replace(/(\n|\r\n)/g, "<br/>")
        	html_content = html_content.replace(/<img/g, '<img class="responsive-image" ');
    		return html_content
	},
    }	
  }
</script>
<style>
.aspect-ratio-16x9 {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio (9 / 16 * 100) */
  overflow: hidden;
}

.aspect-ratio-16x9 iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
